import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import Grid from '@mui/material/Grid';
import {
    FormGroup,
    FormControlLabel,
    Checkbox, Typography
} from "@mui/material";
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CrudButtons from '../../../GlobalFunction/CrudButtons';
import CustomAutocomplete from '../../../Components/AutoComplete/AutoComplete';
// import { useModulePermissions } from '../../../GlobalFunction/useModulePermissions';

const CustomTextField = styled(TextField)(({ theme }) => ({
    '& .MuiFilledInput-root': {
        backgroundColor: 'transparent',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
    },
    '& .Mui-focused': {
        borderColor: '#673ab7',
    },
    '& .MuiFilledInput-root.Mui-focused': {
        border: '1px solid #673ab7',
    },
}));

const PaymentGatewayConfig = () => {

    const [formData, setFormData] = useState({
        PropName: '',
        AuthToken: '',
        ApiKey: '',
        SaltKey: '',
        ClientSecretKey: '',
        ClientKey: ''
    });

    // const permissions = useModulePermissions("Payment Gateway Configuration");

    const [error, setError] = useState({
        AuthToken: false,
        ApiKey: false,
        SaltKey: false
    });

    const navigate = useNavigate();

    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [property, setProperty] = useState([]);
    const location = useLocation();
    const [currentPgConfigId, setCurrentPgConfigId] = useState(null);
    const [mode, setMode] = useState('view');
    const [lastInsertedPgConfigId, setLastInsertedPgConfigId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [Status, setStatus] = useState("0");
    const UserId = sessionStorage.getItem('UserId')

    const PropRef = useRef(null);
    const AuthTokenRef = useRef(null);
    const ApiKeyRef = useRef(null);
    const SaltKeyRef = useRef(null);
    const ClientSecretKeyRef = useRef(null);
    const ClientKeyRef = useRef(null);

    useEffect(() => {
        if (location.state && location.state.PgConfigId) {
            setCurrentPgConfigId(location.state.PgConfigId);
            fetchPaymentGatewayConfigData(location.state.PgConfigId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    const fetchPaymentGatewayConfigData = async (id, flag) => {

        try {
            const response = await axios.post(`PytGatewayConfig/RetrivePytGatewayConfig`, {
                PgConfigId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const paymentGatewayConfigData = response.data.Data[0];
                setFormData({
                    PropName: paymentGatewayConfigData.PropId.toString(),
                    AuthToken: paymentGatewayConfigData.AuthToken,
                    ApiKey: paymentGatewayConfigData.ApiKey,
                    SaltKey: paymentGatewayConfigData.SaltKey,
                    ClientSecretKey: paymentGatewayConfigData.ClientSecretKey,
                    ClientKey: paymentGatewayConfigData.ClientKey
                });
                setStatus(paymentGatewayConfigData.Status.toString() || "0");
                setIsFormDisabled(true);
                setCurrentPgConfigId(paymentGatewayConfigData.PgConfigId);

            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.error('Failed to fetch payment gateway config data');
            }
        } catch (error) {
            console.error('Error fetching payment gateway config data:', error);
            toast.error('Error fetching payment gateway config data. Please try again.');
        }
    };

    const handlePrevious = async () => {
        if (currentPgConfigId && currentPgConfigId > 1) {
            await fetchPaymentGatewayConfigData(currentPgConfigId, "P");
        }
    };

    const handleNext = async () => {
        if (currentPgConfigId) {
            await fetchPaymentGatewayConfigData(currentPgConfigId, "N");
        }
    };

    useEffect(() => {
        const fetchProperty = async () => {
            try {
                const response = await axios.post(`PropertyMst/getPropertyMstdrp`, {
                    UserId,
                    Flag: ""
                });
                if (
                    response.data.Status === 0 &&
                    response.data.responseStatusCode === 1
                ) {
                    setProperty(response.data.Data);
                } else {
                    toast.error("Failed to fetch PropertyName");
                }
            } catch (error) {
                console.error("Error fetching PropertyName", error);
                toast.error("Error fetching PropertyName. Please try again.");
            }
        };

        fetchProperty();
    }, []);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (name === 'PaymentGatewayConfig') {
            setFormData(prevState => ({
                ...prevState,
                state: ''
            }));
        }

        if (name === 'PaymentGatewayConfig' && value !== '') {
            setTimeout(() => {
                PropRef.current.focus();
            }, 100000);
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === PropRef.current) {
                ApiKeyRef.current.focus();
            } else if (event.target === ApiKeyRef.current) {
                AuthTokenRef.current.focus();
            } else if (event.target === AuthTokenRef.current) {
                SaltKeyRef.current.focus();
            } else if (event.target === SaltKeyRef.current) {
                ClientSecretKeyRef.current.focus();
            } else {
                ClientKeyRef.current.focus();
            }
        }
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleSave = async () => {

        let hasError = false;

        if (!formData.AuthToken) {
            toast.error('AuthToken is required');
            setError(prev => ({ ...prev, AuthToken: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, AuthToken: false }));
        }

        if (!formData.ApiKey) {
            toast.error('ApiKey is required');
            setError(prev => ({ ...prev, ApiKey: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, ApiKey: false }));
        }

        if (!formData.SaltKey) {
            toast.error('SaltKey is required');
            setError(prev => ({ ...prev, SaltKey: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, SaltKey: false }));
        }

        if (hasError) {
            return;
        }

        try {
            const payload = {
                PropId: parseInt(formData.PropName),
                AuthToken: formData.AuthToken,
                ApiKey: formData.ApiKey,
                SaltKey: formData.SaltKey,
                ClientSecretKey: formData.ClientSecretKey,
                ClientKey: formData.ClientKey,
                Status: "1",
                CreatedBy: 2
            };

            let response;
            if (mode === 'edit') {
                payload.PgConfigId = currentPgConfigId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axios.patch('PytGatewayConfig/UpdatePytGatewayConfig', payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axios.post('PytGatewayConfig/InsertPytGatewayConfig', payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedPgConfigId(response.data.Data)
                    await fetchPaymentGatewayConfigData(response.data.Data);
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentPgConfigId(response.data.Data);
                } else {
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            console.error('Error saving/updating payment gateway config', error);
            toast.error('Error saving/updating payment gateway config. Please try again.');
        }
    };

    const handleEdit = () => {
        setMode('edit');
        setIsFormDisabled(false);
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            PropName: '',
            AuthToken: '',
            ApiKey: '',
            SaltKey: '',
            ClientSecretKey: '',
            ClientKey: ''
        });
        setCurrentPgConfigId(null);

        setTimeout(() => {
            PropRef.current.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            await fetchPaymentGatewayConfigData(1, "L");
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const resetForm = () => {
        setFormData({
            PropName: '',
            AuthToken: '',
            ApiKey: '',
            SaltKey: '',
            ClientSecretKey: '',
            ClientKey: ''
        });
        setCurrentPgConfigId(null);
        setMode('view');
    };

    const handleExit = () => {
        navigate('/paymentGatewayConfigTable')
    }

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        setOpenConfirmDialog(false);
        try {
            await fetchPaymentGatewayConfigData(currentPgConfigId, "D");
            await fetchPaymentGatewayConfigData(currentPgConfigId, "N");
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            console.error('Error deleting payment gateway config', error);
            toast.error('Error occurred while deleting. Please try again.');
        }
    };

    return (
        <>

            <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>

                <ToastContainer />
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentPgConfigId || currentPgConfigId === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                // sx={{ margin: '0px 10px' }}
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentPgConfigId}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            PaymentGateway Master
                        </Typography>
                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName="Payment Gateway Configuration"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onDelete={handleConfirmDelete}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} md={6} lg={6} className='form_field'>
                        <CustomAutocomplete
                            options={property}
                            id="PropName-autocomplete"
                            name='PropName'
                            label={
                                <span>
                                    Select Property <span style={{ color: 'red' }}>*</span>
                                </span>
                            }
                            value={property.find(PropName => PropName.Id == formData.PropName) || null}
                            onChange={handleInputChange}
                            disabled={isFormDisabled}
                            error={error.PropName}
                            helperText={error.PropName ? '' : ''}
                            ref={PropRef}
                            onKeyDown={handleKeyPress}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={6} className='form_field'>
                        <TextField
                            id="ApiKey"
                            name="ApiKey"
                            label="ApiKey"
                            variant="filled"
                            fullWidth
                            className="custom-textfield"
                            value={formData.ApiKey}
                            onChange={handleInputChange}
                            disabled={isFormDisabled}
                            error={error.ApiKey}
                            helperText={error.ApiKey ? '' : ''}
                            inputRef={ApiKeyRef}
                            onKeyDown={handleKeyPress}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={6} className='form_field'>
                        <TextField
                            id="AuthToken"
                            name="AuthToken"
                            label="AuthToken"
                            variant="filled"
                            fullWidth
                            className="custom-textfield"
                            value={formData.AuthToken}
                            onChange={handleInputChange}
                            disabled={isFormDisabled}
                            error={error.AuthToken}
                            helperText={error.AuthToken ? '' : ''}
                            inputRef={AuthTokenRef}
                            onKeyDown={handleKeyPress}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={6} className='form_field'>
                        <TextField
                            id="SaltKey"
                            name="SaltKey"
                            label="SaltKey"
                            variant="filled"
                            fullWidth
                            className="custom-textfield"
                            value={formData.SaltKey}
                            onChange={handleInputChange}
                            disabled={isFormDisabled}
                            error={error.SaltKey}
                            helperText={error.SaltKey ? '' : ''}
                            inputRef={SaltKeyRef}
                            onKeyDown={handleKeyPress}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} className='form_field'>
                        <TextField
                            id="ClientSecretKey"
                            name="ClientSecretKey"
                            label="ClientID"
                            variant="filled"
                            fullWidth
                            className="custom-textfield"
                            value={formData.ClientSecretKey}
                            onChange={handleInputChange}
                            disabled={isFormDisabled}
                            error={error.ClientSecretKey}
                            helperText={error.ClientSecretKey ? '' : ''}
                            inputRef={ClientSecretKeyRef}
                            onKeyDown={handleKeyPress}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={4} className='form_field'>
                        <TextField
                            id="ClientKey"
                            name="ClientKey"
                            label="Client SecretKey"
                            variant="filled"
                            fullWidth
                            className="custom-textfield"
                            value={formData.ClientKey}
                            onChange={handleInputChange}
                            disabled={isFormDisabled}
                            inputRef={ClientKeyRef}
                            onKeyDown={handleKeyPress}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={2}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        disabled={isFormDisabled}
                                        checked={Status === "1"}
                                        onChange={handleChangeStatus}
                                    />
                                }
                                label="Status"
                            />
                        </FormGroup>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #d4d4d4)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #b9d0e9, #e9f2fa)' }} onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave} >
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default PaymentGatewayConfig;